import React from "react";
import PropTypes from "prop-types";
import { Form as FormikForm, InputField } from "components/common_components/Formik";
import Grid from "@material-ui/core/Grid";
import * as Yup from "yup";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";

function Form({ data, resources, mode, ...rest }) {
    const validationSchema = Yup.object({
        code: Yup.string().required("Required field"),
        type: Yup.string().required("Required field"),
    });

    return (
        <FormikForm initialValues={data} validationSchema={validationSchema} {...rest}>
            <div className="layout">
                <Grid container spacing={3}>
                    <Grid item xs={4}>
                        <FormControl component="fieldset">
                            <FormGroup row>
                                <InputField disabled={mode === "update"} fieldName="code" label="Code *" uppercase fullWidth={false} />
                                <InputField fieldName="type" label="Type *" />
                            </FormGroup>
                        </FormControl>
                    </Grid>
                </Grid>
            </div>
        </FormikForm>
    );
}

Form.propTypes = {
    data: PropTypes.shape({
        code: PropTypes.string,
        type: PropTypes.string,
    }),
    mode: PropTypes.oneOf(["add", "update"]).isRequired,
};

Form.defaultProps = {
    data: {
        code: "",
        type: "",
    },
};

export default Form;
